export default __webpack_public_path__ + "static/media/journal2image2.12d1ab5f.JPG";